/**
* CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const ctas = document.querySelectorAll( '.cta__title' );

      ctas.forEach( ( title ) => {
        const section = title.closest( '[data-component]' );
        const beam = section.querySelector( '.cta__beam' );
        const stand = section.querySelector( '.cta__stand' );

        if ( !beam || !stand ) return;

        gsap.set( [title, beam], {transformOrigin: 'center center'} );
        gsap.set( stand, {transformOrigin: 'center center'} );

        ScrollTrigger.create( {
          trigger: section,
          start: 'top 85%',
          once: true,
          onEnter: () => {
            const tl = gsap.timeline( {repeat: -1, yoyo: true, defaults: {ease: 'power1.inOut'}} );

            tl.to( [title, beam], {rotation: 3, duration: 1.2} )
                .to( [title, beam], {rotation: -3, duration: 1.2} )

                .to( stand, {rotation: 24, x: -24, duration: 1.2}, 0 )
                .to( stand, {rotation: -24, x: 24, duration: 1.2}, 1.2 );
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'cta', COMPONENT );
} )( app );
